<template>
  <Popup
    :title="$t('promote.title')"
    :isVisible="isVisible"
    size="large"
    @close="$emit('close')"
  >
    <!-- <p v-for="n in 10" :key="n" class="col__black">
        This is some content that will eventually cause a scrollbar to appear.
        Item {{ n }}
      </p> -->
    <div
      class="col__black d-flex flex-column align-items-center gap-3 overflow-hidden mega-wrapper"
    >
      <p
        class="section-title fz-Nesspresso text-center text-uppercase fz-40 fw-bold"
        v-html="$t('mega.title')"
      ></p>
      <p
        class="section-desc fz-Nesspresso text-center max-w-566 fz-16 fw-light"
        v-html="$t('mega.desc')"
      ></p>

      <!-- Button Tab Test Section -->
      <div class="button-tab-test w-full">
        <div class="d-flex gap-3 justify-content-center flex-wrap">
          <ButtonTab
            :text="$t('mega.tab_mini')"
            :value="'essenzaMini'"
            :is-selected="selectedTab === 'essenzaMini'"
            @tab-click="handleTabClick"
          />
          <ButtonTab
            :text="$t('mega.tab_verto')"
            :value="'vertuoPop'"
            :is-selected="selectedTab === 'vertuoPop'"
            @tab-click="handleTabClick"
          />
        </div>
        <!-- <p class="text-center mt-2">Selected: {{ selectedTab }}</p> -->

        <!-- product info part -->
        <div class="product-info-section d-flex gap-4 mt-4">
          <!-- Left side - Product Images -->
          <div
            class="product-images-container d-flex flex-column align-items-center position-relative"
          >
            <!-- Main product image -->
            <div class="main-product-image">
              <ImageWrapper
                src="/assets/images/2025/mega_bg.png"
                class="mega-bg"
                alt=""
              />
              <ImageWrapper
                :src="currentProduct ? currentProduct.img : ''"
                :alt="currentProduct ? currentProduct.title : ''"
                class="product"
              />
            </div>
          </div>

          <!-- Right side - Product Info -->
          <div class="product-info-details">
            <div class="product-content__inner">
              <!-- Product Title -->
              <h2
                class="product-title col__productName"
                v-html="currentProduct.title"
              ></h2>

              <div class="mega__product--info">
                <div class="mega__product--info__left">
                  <!-- Product Specifications List -->
                  <ul class="product-description">
                    <li
                      v-for="(spec, index) in currentProduct.specf"
                      :key="index"
                    >
                      {{ spec }}
                    </li>
                  </ul>
                </div>
                <div class="mega__product--info__right">
                  <!-- Price Section -->
                  <div class="price-section">
                    <div class="current-price">
                      {{ currentProduct.price }}
                    </div>
                    <div class="price-details">
                      <span class="original-price">{{
                        currentProduct.originalPrice
                      }}</span>
                      <div class="discount-badge">
                        <span class="discount-percentage">{{
                          currentProduct.discount
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Special Remarks -->
                  <p v-if="currentProduct.remarks" class="product-remarks">
                    {{ currentProduct.remarks }}
                  </p>

                  <div class="product-details-row hide-desktop">
                    <!-- Color Selection -->
                    <div
                      class="color-selection"
                      v-if="availableColors.length > 1"
                    >
                      <p class="color-label">
                        <span class="color-label-text">{{
                          $t("productSection.colorSelected")
                        }}</span>
                        <span class="selected-color-name">{{
                          currentProduct.colorName
                        }}</span>
                      </p>
                      <div class="color-options">
                        <div
                          v-for="(color, index) in availableColors"
                          :key="index"
                          class="color-option"
                          :class="{ active: currentColorIndex === index }"
                          @click="selectColor(index)"
                        >
                          <div
                            class="color-circle"
                            :style="{ backgroundColor: color.colorCode }"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Add to Cart Buttons - All SKUs -->
                  <div class="add-to-cart-section">
                    <!-- Mini Products - All SKUs -->
                    <div v-show="selectedTab === 'essenzaMini'">
                      <addToCart
                        v-for="(product, index) in $t('mega.mini')"
                        :key="product.SKU"
                        :id="product.SKU"
                        v-show="selectedMiniIndex === index"
                      />
                    </div>

                    <!-- Vertuo Products - All SKUs -->
                    <div v-show="selectedTab === 'vertuoPop'">
                      <addToCart
                        v-for="(product, index) in $t('mega.verto')"
                        :key="product.SKU"
                        :id="product.SKU"
                        v-show="selectedVertuoIndex === index"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Product Details Row -->
              <div class="product-details-row hide-mobile">
                <!-- Color Selection -->
                <div class="color-selection" v-if="availableColors.length > 1">
                  <p class="color-label">
                    <span class="color-label-text">{{
                      $t("productSection.colorSelected")
                    }}</span>
                    <span class="selected-color-name">{{
                      currentProduct.colorName
                    }}</span>
                  </p>
                  <div class="color-options">
                    <div
                      v-for="(color, index) in availableColors"
                      :key="index"
                      class="color-option"
                      :class="{ active: currentColorIndex === index }"
                      @click="selectColor(index)"
                    >
                      <div
                        class="color-circle"
                        :style="{ backgroundColor: color.colorCode }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from "../molecules/Popup.vue";
import ButtonTab from "../atoms/ButtonTab.vue";
import addToCart from "../atoms/addToCart.vue";
import ImageWrapper from "../atoms/ImageWrapper.vue";
export default {
  name: "MegaOfferPopup",
  components: {
    Popup,
    ButtonTab,
    addToCart,
    ImageWrapper,
  },
  props: {
    /**
     * Controls the visibility of the popup
     */
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedTab: "essenzaMini",
      selectedMiniIndex: 0,
      selectedVertuoIndex: 0,
    };
  },

  computed: {
    /**
     * Returns the current product data based on selected tab and color index
     */
    currentProduct() {
      if (this.selectedTab === "essenzaMini") {
        return this.$t("mega.mini")[this.selectedMiniIndex];
      } else {
        return this.$t("mega.verto")[this.selectedVertuoIndex];
      }
    },

    /**
     * Returns available colors for the current product type
     */
    availableColors() {
      if (this.selectedTab === "essenzaMini") {
        return this.$t("mega.mini");
      } else {
        return this.$t("mega.verto");
      }
    },

    /**
     * Returns the current color index based on selected tab
     */
    currentColorIndex() {
      if (this.selectedTab === "essenzaMini") {
        return this.selectedMiniIndex;
      } else {
        return this.selectedVertuoIndex;
      }
    },
  },

  methods: {
    /**
     * Handles tab click event to switch between product types
     * @param {string} tabValue - The selected tab value ('essenzaMini' or 'vertuoPop')
     */
    handleTabClick(tabValue) {
      this.selectedTab = tabValue;
    },

    /**
     * Handles color selection for the current product type
     * @param {number} colorIndex - The index of the selected color
     */
    selectColor(colorIndex) {
      if (this.selectedTab === "essenzaMini") {
        this.selectedMiniIndex = colorIndex;
      } else {
        this.selectedVertuoIndex = colorIndex;
      }
    },

    /**
     * Returns the image path for accessory items
     * @param {string} specName - The specification/accessory name
     * @returns {string} The image path for the accessory
     */
    getAccessoryImage(specName) {
      return "/assets/images/2025/default_accessory.png";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .mega-wrapper {
    .section-title {
      @include media-breakpoint-down(md) {
        font-size: rem(32);
        margin-top: rem(16);
      }
    }
    // .section-desc{
    //   @include media-breakpoint-down(md) {

    //   }
    // }
  }
  .mega__product--info {
    display: flex;
    justify-content: space-around;
    width: 100%;
    gap: rem(24);

    .shop-now-btn {
      margin-top: rem(24);
    }

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    .add-to-cart-section {
      margin-top: rem(16);
      display: flex;
    }
  }

  .mega__product--info__right {
    white-space: nowrap;

    .add-to-cart-section > div {
      width: 100%;
    }

    .price-section {
      @include media-breakpoint-down(md) {
        align-items: flex-start !important;
      }
    }

    .product-remarks {
      @include media-breakpoint-down(md) {
        align-self: flex-start !important;
        // margin-bottom: rem(16) !important;
        text-align: left !important;
      }
    }
  }

  .mega__product--info__left {
    display: flex;
    flex-direction: column;
    gap: rem(24);
  }

  .product-info-section {
    max-width: rem(1024);
    margin: auto;

    .product-images-container {
      flex: 0 0 auto;
      min-width: 300px;
      width: 40%;

      .main-product-image {
        position: relative;
        .mega-bg {
          position: absolute;
          top: 33%;
          left: 42%;
          transform: translate(-50%, -50%);
          width: auto;
          height: 42%;
          object-fit: cover;
          max-width: unset;
        }

        .product {
          position: relative;
          max-width: rem(404);
        }

        // img {
        //   filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
        // }
      }

      .accessories-images {
        .accessory-image {
          img {
            transition: opacity 0.3s ease;

            &:hover {
              opacity: 1 !important;
            }
          }
        }
      }
    }

    .product-info-details {
      flex: 1;
      min-width: 0;

      .product-content__inner {
        max-width: rem(603);
        padding: rem(24);
        margin: auto;
        gap: rem(24);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;

        @include media-breakpoint-down(md) {
          gap: rem(16);
          padding: rem(16);
        }

        .product-title {
          font-weight: 700;
          font-size: rem(32);
          line-height: 1.2;
          letter-spacing: rem(3.2);
          text-transform: uppercase;
          text-align: left;
          margin: 0;

          @include media-breakpoint-down(md) {
            font-size: rem(24);
            letter-spacing: rem(2.4);
          }
        }

        .product-description {
          list-style-type: disc;
          padding-left: 1em;
          // font-weight: 600;
          font-size: rem(16);
          line-height: normal;
          color: color(black);
          margin: 0;

          @include media-breakpoint-down(md) {
            font-size: rem(14);
          }
        }

        .product-details-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          width: 100%;
          gap: rem(24);

          @include media-breakpoint-down(md) {
            flex-direction: column;
            gap: rem(16);
          }

          .color-selection {
            display: flex;
            flex-direction: column;
            gap: rem(8);
            opacity: 0.8;

            .color-label {
              font-size: rem(16);
              line-height: 1.2;
              letter-spacing: rem(0.8);
              color: color(black);
              margin: 0;

              .color-label-text {
                font-weight: 400;
              }

              .selected-color-name {
                font-weight: 700;
              }
            }

            .color-options {
              display: flex;
              gap: rem(8);

              .color-option {
                width: rem(34);
                height: rem(34);
                border-radius: 50%;
                border: 2px solid transparent;
                cursor: pointer;
                transition: all 0.3s ease;
                display: flex;
                align-items: center;
                justify-content: center;

                &.active {
                  border-color: color(nespressoBrown);
                  transform: scale(1.1);
                }

                &:hover {
                  transform: scale(1.05);
                }

                .color-circle {
                  width: rem(26);
                  height: rem(26);
                  border-radius: 50%;
                  border: 1px solid rgba(0, 0, 0, 0.1);
                }
              }
            }
          }
        }
      }

      .price-section {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: rem(4);

        @include media-breakpoint-down(md) {
          align-items: center;
        }

        .current-price {
          font-weight: 700;
          font-size: rem(48);
          line-height: normal;
          color: color(black);

          @include media-breakpoint-down(md) {
            font-size: rem(32);
          }
        }

        .price-details {
          display: flex;
          align-items: center;
          gap: rem(8);

          .original-price {
            font-weight: 300;
            font-size: rem(24);
            line-height: normal;
            color: color(black);
            text-decoration: line-through;
            text-decoration-skip-ink: none;
            text-underline-position: from-font;

            @include media-breakpoint-down(md) {
              font-size: rem(12);
            }
          }

          .discount-badge {
            background: color(errorRed);
            color: color(white);
            padding: rem(2) rem(8);
            height: rem(28);
            display: flex;
            align-items: center;
            gap: rem(4);

            .discount-percentage {
              font-weight: 700;
              font-size: rem(16);
              letter-spacing: rem(1.6);

              @include media-breakpoint-down(md) {
                font-size: rem(12);
              }
            }

            @include media-breakpoint-down(md) {
              font-size: rem(12);
              height: unset;
            }
          }
        }
      }
    }

    .product-remarks {
      font-size: rem(12);
      font-weight: 600;
      color: color(black);
      text-align: right;
      margin: 0;
      align-self: flex-end;
    }

    // Responsive design
    @include media-breakpoint-down(lg) {
      flex-direction: column;

      .product-images-container {
        min-width: auto;
        width: 100%;

        .main-product-image {
          img {
            max-width: 250px;
          }
        }
      }
    }

    @include media-breakpoint-down(md) {
      .product-images-container {
        .main-product-image {
          img {
            max-width: 200px;
          }
        }

        .accessories-images {
          .accessory-image {
            img {
              max-width: 60px;
            }
          }
        }
      }
    }
  }
}
</style>
